import { ReactElement } from 'react';

import { useTranslation } from 'modules/i18n';

import { StakingTable as Table } from '../StakingTable';
import { ITableRowProps, TableRow } from './TableRow';
import { translation } from './translation';

interface ILiquidStakingTableProps {
  rows: ITableRowProps[];
}

export function LiquidStakingTable({
  rows,
}: ILiquidStakingTableProps): ReactElement {
  const { keys, t } = useTranslation(translation);

  return (
    <Table>
      <Table.Head>
        <Table.Row>
          <Table.HeadCell>{t(keys.asset)}</Table.HeadCell>

          <Table.HeadCell>{t(keys.apy)}</Table.HeadCell>

          <Table.HeadCell>{t(keys.myPosition)}</Table.HeadCell>

          <Table.HeadCell align="right">{t(keys.actions)}</Table.HeadCell>
        </Table.Row>
      </Table.Head>

      <Table.Body>
        {rows.map(row => (
          <TableRow key={row.tokenAddress} {...row} />
        ))}
      </Table.Body>
    </Table>
  );
}
